import React, { useRef, useState } from "react";
import { Upload } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function FlyerUpload({ onUploaded }) {
  const { t } = useApp();
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/uploads/flyer", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      toast.success(t("uploadDone"));
    } catch (err) {
      toast.error(err.response?.data?.detail || t("uploadFailed"));
    }
    setBusy(false);
    e.target.value = "";
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={pick} data-testid="flyer-file-input" />
      <button type="button" disabled={busy} onClick={() => ref.current?.click()} className="gg-btn" data-testid="flyer-upload-btn">
        <Upload className="w-4 h-4" /> {busy ? t("uploading") : t("uploadFlyer")}
      </button>
      <span className="text-xs text-muted-foreground">{t("uploadHint")}</span>
    </div>
  );
}
